<!--- Formulario FrmWorkerRecords ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-

Eventos escuchados por el formulario:
-----------------------

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <f7-page>
    <template #fixed>
      <TheNavbar
        nav-title="Marcajes Trabajador"
        back-btn-enable
      />
    </template>

    <f7-block class="main-worker-records no-margin padding bg-darkgray">
      <UCSearchEntityERP
        ref="UCWorkersComponent"
        :placeholder="$t('searchEntity.worker.placeholder.numberNameFirstLastName')"
        :search-text="$t('searchEntity.worker.searchText')"
        :search-cancellation-text="$t('searchEntity.worker.searchCancellationText')"
        :search-not-found-text="$t('searchEntity.worker.searchNotFoundText')"
        :end-point-for-code-search="GetWorkerCodeSearch"
        :end-point-for-list="GetWorkerList"
        :property-entity-shown-input="['Codigo', 'Sujeto.NombreSujeto']"
        :property-entity-shown-list-title="['Sujeto.NombreSujeto']"
        :property-entity-shown-list-subtitle="['Codigo']"
        :min-text-search="1"
        :autofocus-on-deselection="true"
        :auto-focus-on-empty-search-result="true"
        @selection="EventselectedWorker"
      />
    </f7-block>
    <f7-block class="content-titulo-select no-margin no-padding-left no-padding-right bg-lightsnow">
      <PCWorkerDetailsRecords
        v-if="selectedWorker != null"
        :worker-selected-default="selectedWorker"
        :show-selector-consultation-date="true"
        :show-time-seconds="true"
      />
    </f7-block>
  </f7-page>
</template>

<script>
import { mapWritableState } from 'pinia';
import { usePresenceStore } from '@/js/stores/presence';

import { Log } from '@/js/common/HIDebuggingSupport';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import PCWorkerDetailsRecords from '@/components/presence/workerRecords/PCWorkerDetailsRecords.vue';
import APIErp from '@/js/services/APIErp';
import TheNavbar from '@/components/TheNavbar.vue';

export default {
  name: 'FrmWorkerRecords',
  components: {
    UCSearchEntityERP,
    PCWorkerDetailsRecords,
    TheNavbar,
  },
  props: {
    // Trabajador seleccionado al inicializar el formulario.
    workerSelectedDefault: {
      type: Object,
      default: null,
    },
  },

  computed: {
    ...mapWritableState(usePresenceStore, ['selectedWorker']),
  },

  mounted() {
    this.StartForm();
  },
  beforeUnmount() {
    this.selectedWorker = null;
  },
  methods: {
    StartForm() {
      Log(this, this.StartForm.name);
      if (this.workerSelectedDefault !== undefined && this.workerSelectedDefault != null) {
        this.$refs.UCWorkersComponent.SelectEntity(this.workerSelectedDefault, true);
      }
    },

    GetWorkerCodeSearch(params) {
      Log(this, this.GetWorkerCodeSearch.name);
      return APIErp.callWorkerSearchText(params);
    },
    GetWorkerList() {
      Log(this, this.GetWorkerList.name);
      return APIErp.callWorkerList();
    },
    EventselectedWorker(objWorker) {
      Log(this, this.EventselectedWorker.name);
      this.selectedWorker = objWorker;
    },
  },
};
</script>

<style lang="scss">
.content-tab {
  .tab-link-highlight {
    display: none;
  }

  .tab-link {
    border-right: 1px solid #ececec;
    border-bottom: 1px solid #ececec;

    .tabbar-label {
      color: var(--his-dark-blue);
      text-transform: none;
      font-size: 14px;
      opacity: 0.7;
      font-weight: 500;
    }
  }

  .tab-link-active {
    border-bottom: 4px solid var(--his-silver);
    background: linear-gradient(var(--his-coconut-milk), #fff);

    .tabbar-label {
      opacity: 1;
      font-size: 16px;
      font-weight: 700;
      color: var(--his-dark-blue);
    }
  }
}

.div-registroDeMarcaje {
  padding-top: 8px;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid var(--his-disabled);
}

.div-registrosDeMarcajes {
  background: #fff;
}

.div-componenteDeBusquedaTrabajador {
  min-height: 82px;
  background-color: var(--his-tierra-white);
  margin-top: -15px;
  padding-top: 15px;
  padding-bottom: 5px;
}

/** toolbar TAB */
.toolbar-pestañasTab {
  background: var(--his-tierra-white);
}

.img-iconoAccesoResumenActividadTrabajador {
  width: 28px;
  height: 28px;
  padding-top: 12px;
  padding-bottom: 0;
}
</style>
